import ArchivePostPage from "./ArchivePostPage";

export default ArchivePostPage;